

// glide
if(document.querySelector('.home')) {

}